import React, { memo } from 'react'

import { Avatar } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  node, shape, string,
} from 'prop-types'

import DesktopOnlyTooltip from 'Pods/Shared/DesktopOnlyTooltip/DesktopOnlyTooltip'

// Creator avatar with a hover-only username tooltip, shared by the AI Studio
// model footer and the community gallery card. Presentational: the caller
// supplies the creator, the tooltip copy, and the BEM classes, so each consumer
// owns its own placement (footer: always visible; card: hidden below 640px via
// its own SCSS). The tooltip itself is dropped below 640px by DesktopOnlyTooltip.
function CreatorAvatar({
  user = null,
  tooltipContent = null,
  id,
  place = '',
  containerClass = '',
  className = '',
}) {
  if (!user?.username) return null

  return (
    <DesktopOnlyTooltip
      id={id}
      content={tooltipContent}
      place={place}
      containerClass={containerClass}
    >
      <Avatar
        className={className}
        size="32"
        img={user.avatar_url || ''}
        username={user.username}
        useSingleLetter
      />
    </DesktopOnlyTooltip>
  )
}

CreatorAvatar.propTypes = {
  user: shape({ username: string, avatar_url: string }),
  tooltipContent: node,
  id: string.isRequired,
  place: string,
  containerClass: string,
  className: string,
}

export default memo(CreatorAvatar)
